import { BaseActivityBasicModel } from '../base-activity-basic.model';

export interface WhatsAppActivityBasicModel extends BaseActivityBasicModel {}
